<div
  class="ui left icon input"
  [ngClass]="{
    currency: question?.isCurrency,
    'right percentage': question?.isPercentage
  }"
>
  @if (!config.featureFlags.displayNumberUsingThousandsFormat) {
  <input
    #inputEl
    type="number"
    step="{{ decimalPlace }}"
    [formControl]="myFormControl"
    (focus)="isFocused = true"
    (blur)="onBlur()"
    (keyup)="question.dataType === 'integer' && onlyNumbers()"
    [attr.disabled]="disabled"
    [attr.autofocus]="autofocus"
    id="{{ 'question-input-' + question.id }}"
    class="no-controls"
    [attr.tabindex]="tabIndex"
  />
  } @if (config.featureFlags.displayNumberUsingThousandsFormat) {
  <input
    #inputEl
    type="text"
    step="{{ decimalPlace }}"
    [formControl]="myFormControl"
    (focus)="onFocus()"
    (blur)="onBlur()"
    (keyup)="preventAlpha() && question.dataType === 'integer' && onlyNumbers()"
    [attr.disabled]="disabled"
    [attr.autofocus]="autofocus"
    id="{{ 'question-input-' + question.id }}"
    class="no-controls"
    value="{{ numWithThousandsFormat }}"
    [attr.tabindex]="tabIndex"
  />
  } @if (question?.isCurrency || question?.isPercentage) {
  <i
    class="icon"
    [ngClass]="{
      dollar: question?.isCurrency,
      percent: question?.isPercentage
    }"
  ></i>
  }
</div>

@if (myFormControl?.errors) {
<div class="clear validation-text">
  @if (myFormControl?.errors?.required) {
  <div>{{ question?.question }} {{ "is-required" | transloco }}</div>
  } @if (myFormControl?.errors?.min) {
  <div>
    {{ question?.question }} {{ "must-be-at-least" | transloco }}
    {{ myFormControl?.errors?.min.min }}
  </div>
  } @if (myFormControl?.errors?.max) {
  <div>
    {{ question?.question }} {{ "cannot-be-more-than" | transloco }}
    {{ myFormControl?.errors?.max.max }}
  </div>
  }
</div>
} @if ( myFormControl.value && question?.maxLength && myFormControl?.errors ===
null && isFocused ) {
<div
  class="char-count"
  [ngClass]="{ invalid: myFormControl.value.length >= question.maxLength }"
>
  {{ question.maxLength - myFormControl.value.toString().length }}
  {{ "chars-left" | transloco }}
</div>
}
